/**
 * gs-countdown-timer.js
 * - Reads end date + time from data attributes (set by Liquid schema)
 * - Converts target to US Central Time correctly (handles CST/CDT automatically)
 * - Ticks every second, updates DOM
 * - Auto-hides section when expired (if checkbox enabled)
 */

(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /**
   * Convert "YYYY-MM-DD" + "HH:MM" in US Central Time to a UTC timestamp.
   * Central Time = UTC-6 (CDT summer) or UTC-7 (CST winter).
   * We use the Intl API trick: format a known UTC date in CT and compare offset.
   */

  function getCentralOffset() {
    // Ask Intl directly for Chicago's current wall-clock parts (numeric,
    // no string re-parsing) — this does NOT depend on the visitor's own
    // local timezone, which was the bug in the old version.
    var now = new Date();
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var parts = {};
    fmt.formatToParts(now).forEach(function (p) {
      if (p.type !== 'literal') parts[p.type] = p.value;
    });
    var ctAsUtcMs = Date.UTC(
      parts.year, parts.month - 1, parts.day,
      parts.hour, parts.minute, parts.second
    );
    // Difference between UTC and CT in ms
    return now.getTime() - ctAsUtcMs; // positive = CT behind UTC
  }

  function parseTargetDate(dateStr, timeStr) {
    // dateStr: "YYYY-MM-DD", timeStr: "HH:MM"
    if (!dateStr || !timeStr) return null;

    var parts = dateStr.split('-');
    var timeParts = timeStr.split(':');
    if (parts.length < 3 || timeParts.length < 2) return null;

    var year   = parseInt(parts[0], 10);
    var month  = parseInt(parts[1], 10) - 1; // 0-indexed
    var day    = parseInt(parts[2], 10);
    var hour   = parseInt(timeParts[0], 10);
    var minute = parseInt(timeParts[1], 10);

    // Build as UTC first, then shift by Central offset
    var utcMs = Date.UTC(year, month, day, hour, minute, 0);
    var offset = getCentralOffset(); // ms CT is behind UTC
    return new Date(utcMs + offset); // target moment in real UTC
  }

  function updateTimer(section) {
    var endDate   = section.dataset.endDate;
    var endTime   = section.dataset.endTime;
    var autoHide  = section.dataset.autoHide === 'true';

    var target = parseTargetDate(endDate, endTime);
    if (!target) return;

    var elDays    = section.querySelector('[data-days]');
    var elHours   = section.querySelector('[data-hours]');
    var elMinutes = section.querySelector('[data-minutes]');
    var elSeconds = section.querySelector('[data-seconds]');

    function tick() {
      var now  = new Date();
      var diff = target - now;

      if (diff <= 0) {
        // Timer expired
        if (elDays)    elDays.textContent    = '00';
        if (elHours)   elHours.textContent   = '00';
        if (elMinutes) elMinutes.textContent  = '00';
        if (elSeconds) elSeconds.textContent  = '00';

        if (autoHide) {
          section.classList.add('gs-ct-hidden');
        }
        return; // stop ticking
      }

      var days    = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (elDays)    elDays.textContent    = pad(days);
      if (elHours)   elHours.textContent   = pad(hours);
      if (elMinutes) elMinutes.textContent  = pad(minutes);
      if (elSeconds) elSeconds.textContent  = pad(seconds);

      setTimeout(tick, 1000);
    }

    tick();
  }

  function initAll() {
    document.querySelectorAll('.gs-countdown-timer').forEach(updateTimer);
  }

  // Theme Editor reload support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.gs-countdown-timer');
    if (section) updateTimer(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
